import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, TextInput, Copy, Spinner, Loader } from 'elements';
import { Wrapper, Main, FormRow } from 'components';
import { saveUserDetails, getUsername } from 'actions/user';

class UserDetails extends Component {
  state = {
    name: this.props.name,
    nameError: false,
    nameErrorMessage: '',
    email: this.props.email,
    emailError: false,
    emailErrorMessage: '',
    username: this.props.username,
    usernameError: false,
    usernameErrorMessage: '',
  };

  componentWillMount () {
    const { getUsername } = this.props;

    getUsername();
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.username !== this.props.username) {
      this.setState({ username: nextProps.username });
    }
  }

  handleName = ({ target }) => {
    this.setState({
      name: target.value,
      nameError: false,
      nameErrorMessage: '',
    });
  };

  handleEmail = ({ target }) => {
    this.setState({
      email: target.value,
      emailError: false,
      emailErrorMessage: '',
    });
  };

  handleUsername = ({ target }) => {
    this.setState({
      username: target.value,
      usernameError: false,
      usernameErrorMessage: '',
    });
  };

  validateEmail (email) {
    const regexp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return regexp.test(email);
  }

  validateUsername (username) {
    const regexp = /^\w*[a-zA-Z]\w*$/g;
    return regexp.test(username);
  }

  handleSubmit = () => {
    const { saveUserDetails, history, userId } = this.props;
    const { name, email, username } = this.state;

    const isEmailValid = this.validateEmail(email);
    const isUsernameValid = this.validateUsername(username);

    if (!name) {
      this.setState({
        nameError: true,
        nameErrorMessage: 'Please enter your name',
      });
    } else if (!isEmailValid || !email) {
      this.setState({
        emailError: true,
        emailErrorMessage: 'Please enter a correct email address',
      })
    }
    else if (!isUsernameValid) {
      this.setState({
        usernameError: true,
        usernameErrorMessage: 'Username must have at least one letter and can contain digits and "_" character',
      });
    } else if (!username || username.length < 4) {
       this.setState({
         usernameError: true,
         usernameErrorMessage: 'Username must be at least 4 characters long',
       })
    } else {
      saveUserDetails(userId, name, email, username, history);
    }
  };

  renderErrors () {
    const { saveError, fetchError, usernameExistsError, authError } = this.props;
    const hasError = saveError || fetchError || authError;

    if (hasError) {
      return <Copy type="error" color="white">Something went wrong, please try again</Copy>
    }

    if (usernameExistsError) {
      return <Copy type="error" color="white">This username is already taken</Copy>
    }
  }

  render () {
    const {
      name,
      nameError,
      nameErrorMessage,
      email,
      emailError,
      username,
      usernameError,
      usernameErrorMessage,
      emailErrorMessage
    } = this.state;
    const { saveStart, isFetching } = this.props;

    return (
      <div>
        {
          isFetching ? (
            <Wrapper>
              <Main>
                <Loader />
              </Main>
            </Wrapper>
          ) : (
            <Wrapper>
              {this.renderErrors()}
              <Main>
                <FormRow>
                  <TextInput
                    error={nameError}
                    value={name}
                    placeholder="What is your name?"
                    onChange={this.handleName}
                    type="text"
                  />
                  {nameErrorMessage &&
                  <Copy type="inputError">
                    {nameErrorMessage}
                  </Copy>
                  }
                </FormRow>
                <FormRow>
                  <TextInput
                    error={emailError}
                    value={email}
                    placeholder="Your email address"
                    onChange={this.handleEmail}
                    type="email"
                  />
                  {emailErrorMessage &&
                  <Copy type="inputError">
                    {emailErrorMessage}
                  </Copy>
                  }
                </FormRow>
                <FormRow>
                  <TextInput
                    error={usernameError}
                    value={username}
                    placeholder="Your username"
                    onChange={this.handleUsername}
                    type="text"
                  />
                  {usernameErrorMessage &&
                  <Copy type="inputError">
                    {usernameErrorMessage}
                  </Copy>
                  }
                </FormRow>
                <Button primary onClick={this.handleSubmit} disabled={saveStart}>
                  <Spinner inButton visible={saveStart} />
                  <span>Continue</span>
                </Button>
              </Main>
            </Wrapper>
          )
        }
      </div>
    )
  }
}

const UserDetailsWithRouter = withRouter(UserDetails);

export default connect(state => ({
  saveStart: state.user.userDetailSaveStart,
  saveError: state.user.userDetailSaveError,
  isFetching: state.user.isFetchingUser,
  fetchError: state.user.fetchUserError,
  name: state.user.name,
  username: state.user.username,
  email: state.user.email,
  usernameExistsError: state.user.usernameExists,
  userId: state.user.userId,
  authError: state.user.userAuthError,
}), { saveUserDetails, getUsername })(UserDetailsWithRouter);



// WEBPACK FOOTER //
// ./src/pages/userDetails/userDetails.js